<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>

    <div style="width:100%; box-sizing:border-box; max-width:500px; margin:0px auto; display:block; text-align:center;">

        <span class="regconfirm_text" style="margin-top:20px; margin-bottom:50px;" v-show="RegOK==2">
            <i class="fal fa-exclamation-triangle" style="margin-right:10px;"></i>A regisztráció megerősítése sikertelen!
        </span>

        <span class="regconfirm_text" style="margin-top:20px; margin-bottom:50px;" v-show="RegOK==0">
            <i class="fal fa-spinner fa-spin fa-fw" style="margin-right:10px;"></i>A regisztráció megerősítése folyamatban...
        </span>


        <span class="regconfirm_text" style="margin-top:20px; margin-bottom:50px;" v-show="RegOK==1">
            <i class="fal fa-check" style="margin-right:10px;"></i>A regisztráció megerősítése sikeres!
        </span>

        <br><br>
        <a class="painted_linkbutton color3" href="bejelentkezes" v-show="RegOK!=0">
            <span>Bejelentkezés<i class="fal fa-angles-right" style="margin-left:10px;"></i></span>
        </a>


    </div>




    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmregconfirm',
  components: {
      GrcDB,
      GrcDialog,
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmRegConfirm_",
          RegOK: 0,
      }
  },
  model: {

  },  
  methods:{



    async RegConfirm()
    {
        this.RegOK = 0;

        let pRegConfirmData = "";

        if (GRCAPP_GetParameters.hasOwnProperty("DATA"))
        {
          pRegConfirmData = GRCAPP_GetParameters.DATA;
        }


        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sRegConfirmData: pRegConfirmData,
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Confirm", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.RegOK = 2;
            return;
        }

        if (Q.RESULT[0].intResult == 1)
        {
            this.RegOK = 1;
        }
        else
        {
            this.RegOK = 2;
        }

        this.$refs.GRCDB.HideLoading();
    },




  },
  created()
  {

  },
  mounted()
  {
    this.RegConfirm();
  }

}


</script>


<style scoped>

.regconfirm_text
{
    font-size:20px;
    line-height:30px;
    color:#000;
    font-weight: 500;
}


</style>